import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'

import TopMenuPageLayout from '@/components/TopMenuPageLayout'
import Committees from '@/components/Committees'
import Program from '@/components/Program'
import Programimage from '@/components/Programimage'
import Speaker from '@/components/Speaker'
import Corporate from '@/components/Corporate'
// import Workshop from '@/components/CallForWorkshop'
import Workshop from '@/components/Workshop'
import WorkshopItem from '@/components/WorkshopItem'
import Posters from '@/components/Posters'
import Register from '@/components/Register'
import Hotel from '@/components/Hotel'
// import Sponsors from '@/components/CallForSponsors'
import Sponsors from '@/components/Sponsors'
import Tutorial from '@/components/Tutorial'
import PreWorkshop from '@/components/Workshop'
import APR from '@/components/APR'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
        path: 'other',
        component: TopMenuPageLayout,
        children: [
          {
            path: '/committees',
            name: 'Committees',
            component: Committees
          },
          {
            path: '/program',
            name: 'Program',
            component: Program
          },
          {
            path: '/programimage',
            name: 'Programimage',
            component: Programimage
          },
          {
            path: '/speaker',
            name: 'Speaker',
            component: Speaker
          },
          {
            path: '/corporate',
            name: 'Corporate',
            component: Corporate
          },
          {
            path: '/apr',
            name: 'APR',
            component: APR
          },
          {
            path: '/workshop',
            name: 'Workshop',
            component: Workshop
          },
          {
            path: '/workshopde',
            name: 'WorkshopItem',
            component: WorkshopItem,
            props: { id: 0 }
          },
          {
            path: '/poster',
            name: 'Posters',
            component: Posters
          },
          {
            path: '/register',
            name: 'Register',
            component: Register
          },
          {
            path: '/hotel',
            name: 'Hotel',
            component: Hotel
          },
          {
            path: '/sponsors',
            name: 'Sponsors',
            component: Sponsors
          },
          {
            path: '/tutorial',
            name: 'Tutorial',
            component: Tutorial
          },
          {
            path: '/preworkshop',
            name: 'PreWorkshop',
            component: PreWorkshop,
          },
        ]
      }
  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js